(() => {
  if (window.__smCartShippingProgress) return;
  window.__smCartShippingProgress = true;

  const AMOUNT_PATTERN = /%\s*amount\s*%/i;
  const CART_EVENTS = ['cart-update', 'cart:updated', 'cart-drawer:open', 'cart:refresh'];
  let visibilityObserver;
  let visibilityQueued = false;

  const toBoolean = (value) => value === true || value === 'true';

  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const getSessionItem = (key) => {
    try {
      return window.sessionStorage.getItem(key);
    } catch (_error) {
      return null;
    }
  };

  const setSessionItem = (key, value) => {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (_error) {
      // Ignore storage failures; the URL param still drives the current page.
    }
  };

  const removeSessionItem = (key) => {
    try {
      window.sessionStorage.removeItem(key);
    } catch (_error) {
      // Ignore storage failures.
    }
  };

  const currentAppParam = () => {
    const params = new URLSearchParams(window.location.search);
    let app = params.get('app');

    if (app) {
      setSessionItem('app_param', app);
      return app;
    }

    if (!params.has('app')) {
      removeSessionItem('app_param');
      return '';
    }

    return getSessionItem('app_param') || '';
  };

  const applyContainerVisibility = () => {
    const containers = document.querySelectorAll('.shipping-progress-container');
    if (!containers.length) return;

    const app = currentAppParam();
    const anyRowHasFlag = Boolean(document.querySelector('.cart-items .cart-item[data-hide-shipping="true"]'));

    containers.forEach((container) => {
      const hideForApp = app === 'kinn' && !toBoolean(container.dataset.shippingProgressAppEnabled);
      const hideForCartSettings = app !== 'kinn'
        && (!toBoolean(container.dataset.cartShippingProgressEnabled)
          || !toBoolean(container.dataset.cartPageShippingProgressEnabled));

      container.classList.toggle('hidden', hideForApp || hideForCartSettings || anyRowHasFlag);
    });
  };

  const scheduleContainerVisibility = () => {
    if (visibilityQueued) return;
    visibilityQueued = true;
    window.requestAnimationFrame(() => {
      visibilityQueued = false;
      applyContainerVisibility();
    });
  };

  const currencyFormatter = (progress) => {
    const locale = progress.dataset.locale || document.documentElement.lang || 'en';
    const currency = window.Shopify?.currency?.active || progress.dataset.currency || 'USD';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        currencyDisplay: 'narrowSymbol',
      });
    } catch (_error) {
      return null;
    }
  };

  const formatMoney = (progress, cents) => {
    const formatter = currencyFormatter(progress);
    return formatter ? formatter.format(cents / 100) : (cents / 100).toFixed(2);
  };

  const thresholdCents = (progress) => {
    const baseThreshold = Number.parseInt(progress.dataset.threshold || '0', 10) || 0;
    if (progress.dataset.thresholdSource === 'localized') {
      return baseThreshold;
    }
    const rate = Number.parseFloat(window.Shopify?.currency?.rate || '1') || 1;
    return Math.round(baseThreshold * rate);
  };

  const decodeHtml = (value) => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value || '';
    return textarea.value;
  };

  const excludedCents = (progress, cart) => {
    const excludeHandle = progress.dataset.excludeHandle;
    if (!excludeHandle || !cart?.items?.length) return 0;

    return cart.items.reduce((sum, item) => {
      return item.handle === excludeHandle ? sum + (item.final_line_price || 0) : sum;
    }, 0);
  };

  const buildBelowText = (progress, remaining) => {
    const template = progress.dataset.templateBelow || '';
    const amount = formatMoney(progress, remaining);

    return AMOUNT_PATTERN.test(template)
      ? template.replace(AMOUNT_PATTERN, amount)
      : `${template} ${amount}`.trim();
  };

  const setProgress = (progress, cart) => {
    const threshold = thresholdCents(progress);
    if (!threshold) return;

    const total = Math.max(0, (cart.total_price || 0) - excludedCents(progress, cart));
    const percent = Math.min(100, Math.max(0, Math.round((total / threshold) * 100)));
    const fill = progress.querySelector('.cart-progress__fill');
    const bar = progress.querySelector('.cart-progress__bar');
    const message = progress.querySelector('.cart-progress__msg');

    if (fill) fill.style.width = `${percent}%`;
    if (bar) bar.setAttribute('aria-valuenow', String(percent));

    if (!message) return;

    const messageText = total >= threshold
      ? progress.dataset.templateQualified || ''
      : buildBelowText(progress, threshold - total);

    message.textContent = decodeHtml(messageText);
  };

  const progressBars = () => document.querySelectorAll('[data-sm-cart-shipping-progress]');

  const hydrateProgressBars = () => {
    const bars = progressBars();
    if (!bars.length) return;

    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        progressBars().forEach((progress) => setProgress(progress, cart));
      })
      .catch(() => {
        // Keep server-rendered progress if the cart endpoint is unavailable.
      });
  };

  const scheduleHydration = () => {
    window.setTimeout(hydrateProgressBars, 250);
    window.setTimeout(hydrateProgressBars, 700);
  };

  const init = () => {
    applyContainerVisibility();
    hydrateProgressBars();

    CART_EVENTS.forEach((eventName) => {
      document.addEventListener(eventName, () => {
        scheduleContainerVisibility();
        scheduleHydration();
      });
    });

    if (!visibilityObserver && document.body) {
      visibilityObserver = new MutationObserver(scheduleContainerVisibility);
      visibilityObserver.observe(document.body, { childList: true, subtree: true });
    }
  };

  onReady(init);
})();
